@switch (filter().type) {
  @case (TableFilterType.Text) {
    <app-table-filter-text
      class="w-full"
      (changes)="handleTextFilterChanges($event)" />
  }
  @case (TableFilterType.Number) {
    <app-table-filter-number
      class="w-full"
      (changes)="handleNumberFilterChanges($event)" />
  }
  @case (TableFilterType.Currency) {
    <app-table-filter-currency
      class="w-full"
      (changes)="handleCurrencyFilterChanges($event)" />
  }
  @case (TableFilterType.DateRange) {
    <app-table-filter-date-range
      class="w-full"
      (changes)="handleDateRangeFilterChanges($event)" />
  }
  @case (TableFilterType.DateTimeRange) {
    <app-table-filter-date-range
      class="w-full"
      (changes)="handleDateRangeFilterChanges($event)"
      [showTime]="true" />
  }
  @case (TableFilterType.Select) {
    <app-table-filter-select
      class="w-full"
      (changes)="handleSelectFilterChanges($event)"
      [selectItems]="(filter().selectItems$ | async) ?? []" />
  }
  @case (TableFilterType.MultiSelect) {
    <app-table-filter-multiselect
      class="w-full"
      (changes)="handleMultiSelectFilterChanges($event)"
      [selectItems]="(filter().selectItems$ | async) ?? []" />
  }
  @case (TableFilterType.Boolean) {
    <app-table-filter-select
      class="w-full"
      (changes)="handleSelectFilterChanges($event)"
      [selectItems]="(filter().selectItems$ | async) ?? []" />
  }
  @default {
    Brak definicji filtra dla typu {{ filter().type }}.
  }
}
